const PERMISSION_KEY= "personalize:nebula_statistics";
const PAGE_URL = {
    NEBULA_STATISTICS_PAGE: "/admin/personalize/nebula-statistics"
}

export {PERMISSION_KEY, PAGE_URL}

